import { z } from 'zod/v3';
import { errorMap, zCode, zValidPeriod } from '../../common/utils';
import { ValidationRuleBaseDataSchema } from './ValidationRuleFormDataSchema';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ValidationRuleValidDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-valid-form-data-schema',
);
addTranslations(translations);

export const ValidationRuleValidDataSchema = ValidationRuleBaseDataSchema.omit({
  validFrom: true,
  validTo: true,
}).extend({
  code: zCode(),
  errorLevelId: z.number(errorMap(() => t('validation.required'))).min(1),
  expressionLeft: z.string(errorMap(() => t('validation.required'))).min(1),
  expressionOperatorId: z
    .number(errorMap(() => t('validation.required')))
    .min(1),
  expressionRight: z.string(errorMap(() => t('validation.required'))).min(1),
  statusId: z.number(errorMap(() => t('validation.required'))).min(1),
  tolerance: z.number(errorMap(() => t('validation.negative'))).min(0),
  validPeriod: zValidPeriod(),
});
